import React from 'react'
const photo = require('../../../icon/escarapela.png')



export function TemplateScarapela(props) {

    return (
        <div id="contentScarp" className="wrapp-scarp" style={{ display: 'none' }}>
            {
                props.data.map(e => <div className="item" style={{
                    background: 'url(' + photo + ')', width: 359,
                    height: 235,
                    position: 'relative',
                    display: 'inline-block'
                }}>
                    <img src={e.qr} width="80px" height="80px" style={{ position: 'absolute', right: 5, top: 5 }}></img>
                    <span className="name" style={{ position: 'absolute', fontSize: 36, textTransform: 'uppercase', color: "#000", fontWeight: 'bold', top: 73, left: 85, height: 40, overflow: 'hidden', width: 220, fontFamily: 'sans-serif' }}>{e.alias == 'NN' ? e.name : e.alias}</span>
                    <span className="process" style={{ position: 'absolute', fontSize: 20, textTransform: 'uppercase', color: "#444", top: 130, left: 85, height: 50, overflow: 'hidden', width: 220, fontFamily: 'sans-serif' }}>{props.typeProcess}</span>
                </div>)
            }
        </div>
    )
}